import React from 'react';
import Swiper from 'react-id-swiper';


class ScreenShot extends React.Component {
  render() {
      const params = {
		  effect: 'coverflow',
		  grabCursor: true,
		  initialSlide: 2,
		  centeredSlides: true,
		  loop: true,
		  spaceBetween: 0,
		  slidesPerView: 4,
		  pagination: {},
		  coverflowEffect: {
			  rotate: 0,
			  stretch: 0,
			  depth: 100,
			  modifier: 1.43,
			  slideShadows: false,
		  },
		  autoplay: {
			  delay: 5000,
		  },
		  breakpoints: {
			  360: {
				  slidesPerView: 1,
				  coverflowEffect: {
					  depth: 50,
					  modifier: 0,
				  },
			  },
			  640: {
				  slidesPerView: 3,
				  coverflowEffect: {
					  depth: 80,
					  modifier: 0,
				  },
			  }
		  }
	  }

  	return (
		<section id="screenshots" className="theme-bg screenshots" >
			<div className="container">
				<div className="row">
					<div className="col-md-12 text-center">
						<div className="section-title">
							<h2 className="text-mine-shaft">2022 Calendar Themes</h2>
							<img src="assets/images/white-line.png" alt="title-line" className="img-fluid" />
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-12">
						<Swiper {...params} className="swiper-screenshots-container-1 swiper-container">
							<div className="swiper-slide">
								<a href={`${process.env.PUBLIC_URL}/house-plants`}>
									<img src="assets/images/themes/house_plants/calist_2022_calendar_house_plants_1.png" alt="Calist 2022 Calendar House Plants - January"/>
								</a>
							</div>
							<div className="swiper-slide">
								<a href={`${process.env.PUBLIC_URL}/geometric-shapes`}>
									<img src="assets/images/themes/shapes/calist_2022_calendar_shapes_1.png" alt="Calist 2022 Calendar Geometric Shapes - January"/>
								</a>
							</div>
							<div className="swiper-slide">
								<a href={`${process.env.PUBLIC_URL}/abstract-landmarks`}>
									<img src="assets/images/themes/abstract_landmarks/calist_2022_calendar_abstract_landmarks_1.png" alt="Calist 2022 Calendar Abstract Landmarks - January"/>
								</a>
							</div>
							<div className="swiper-slide">
								<a href={`${process.env.PUBLIC_URL}/geometric-arts`}>
									<img src="assets/images/themes/geometric_arts/calist_2022_calendar_geometric_arts_1.png" alt="Calist 2022 Calendar Geometric Arts - January"/>
								</a>
							</div>
							<div className="swiper-slide">
								<a href={`${process.env.PUBLIC_URL}/landscapes`}>
									<img src="assets/images/themes/landscapes/calist_2022_calendar_landscapes_1.png" alt="Calist 2022 Calendar Landscapes - January"/>
								</a>
							</div>
						</Swiper>
					</div>
				</div>
			</div>
		</section>
  	);
  }
}


export default ScreenShot;


// WEBPACK FOOTER //
// ./src/components/screenshot.js